import { buggyLinkQuery } from "./buggyDeepLink";

/** Identifies transient Vouch query parameters that must be consumed before routing. */
export function hasVouchQuery(search: URLSearchParams): boolean {
  return Array.from(search.keys()).some((key) =>
    key.toLowerCase().startsWith("vc"),
  );
}

/** Keeps the selected language while removing transient Vouch parameters. */
export function canonicalHomeQuery(
  search: URLSearchParams,
): Record<string, string> {
  const query: Record<string, string> = {};
  const lang = search.get("lang")?.trim();
  if (lang) query.lang = lang;
  if (search.get("to") === "buggy") {
    query.to = "buggy";
    Object.assign(query, buggyLinkQuery(Object.fromEntries(search)));
    if (search.get("source") === "dc") query.source = "dc";
    if (["home", "assistance"].includes(search.get("entry") || ""))
      query.entry = search.get("entry")!;
  }
  if (search.get("to") === "assistance" && search.has("assistanceOption")) {
    for (const key of ["to", "assistanceOption", "serviceId", "roomEntry"]) {
      const value = search.get(key);
      if (value) query[key] = value;
    }
    if (search.get("source") === "dc") query.source = "dc";
  }
  return query;
}
